import script from "./PortalWorkspaceError.vue?vue&type=script&setup=true&lang=js"
export * from "./PortalWorkspaceError.vue?vue&type=script&setup=true&lang=js"

import "./PortalWorkspaceError.vue?vue&type=style&index=0&id=4f7c648e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4f7c648e"]])

export default __exports__